// extracted by mini-css-extract-plugin
export var blue = "_1z-g";
export var brand = "_1z-c";
export var darkGrey = "_1z-f";
export var disabled = "_1z-6";
export var disabledSubtle = "_1z-7";
export var error = "_1z-8";
export var green = "_1z-h";
export var grey = "_1z-e";
export var icon = "_1z-0";
export var inherit = "_1z-b";
export var lightGrey = "_1z-d";
export var orange = "_1z-j";
export var pink = "_1z-l";
export var primary = "_1z-1";
export var purple = "_1z-m";
export var quaternary = "_1z-4";
export var quinary = "_1z-5";
export var red = "_1z-k";
export var secondary = "_1z-2";
export var success = "_1z-a";
export var tertiary = "_1z-3";
export var warning = "_1z-9";
export var white = "_1z-n";
export var yellow = "_1z-i";